export default __webpack_public_path__ + "static/media/slider-image3.00a1455f.png";